import React, { useEffect, useState } from "react";
import AddEditFormNotes from "./AddEditFormNotes";
import {
  setAppError,
  setBreadCrumb,
} from "../../../../../../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  Link,
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router-dom";
import PromptElement from "../../../../../PromptElement";
import ListDataNotes from "./ListDataNotes";
import { checkAccessFn } from "../../../../../../../utils/checkAccess";
import { axios } from "../../../../../../../Global";
import { printValidationError } from "../../../../../../../utils/functions";

export default function ContractCostSheetNotes(props) {
  const params = useParams();
  const outletContext = useOutletContext();
  const [showPromptElement, setShowPromptElement] = useState({
    open: false,
    id: null,
  });
  const location = useLocation();
  const currentContractId = params.contractId;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [statusUpdate, setStatusUpdate] = useState(false);
  const [submitFormLoading, setSubmitFormLoading] = useState(false);
  const [loading, setLoading] = useState({
    edit: false,
    delete: false,
    listData: false,
    loadingId: "",
  });
  const [clientList, setClientList] = useState([]);
  const [addOrEdit, setAddOrEdit] = useState({
    open: false,
    method: "",
    loadedValues: {},
    editId: "",
  });

  useEffect(() => {
    if (location.pathname.split("/")[5] === "create") {
      setAddOrEdit((p) => ({ ...p, open: true, method: "add" }));
    } else {
      setAddOrEdit((p) => ({ ...p, open: false }));
    }
  }, [location]);

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState("");

  const token = localStorage.getItem("token");
  const quotationCostSheetId = location.pathname.split("/").at(3);
  useEffect(() => {
    axios
      .get(`/dashboard/contract/${currentContractId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setClientList(res.data.data.notes);
      })
      .catch((err) => {
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
      });
  }, [addOrEdit.open, loading.delete, statusUpdate]);

  const submitForm = async (event) => {
    event.preventDefault();
    setSubmitFormLoading(true);
    try {
      let response;
      const body = {
        name,
        description,
        contract_id: quotationCostSheetId,
      };
      if (addOrEdit.method === "add") {
        response = await axios.post(`/dashboard/contract-note`, body, {
          headers: { Authorization: `Bearer ${token}` },
        });
      } else if (addOrEdit.method === "edit") {
        response = await axios.put(
          `/dashboard/contract-note/${addOrEdit.editId}`,
          { name, description, status },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
      }
      const data = response.data.data;
      if (data) {
        navigate(`/dashboard/contract/${currentContractId}/notes`);
        dispatch(
          setAppError({
            msg: response.data.message,
            color: "bg-green-700",
          })
        );
        setSubmitFormLoading(false);
        setAddOrEdit((p) => ({ ...p, open: false }));
      }
    } catch (err) {
      
      printValidationError(err, "notes");
      setSubmitFormLoading(false);
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };

  const cancelForm = () => {
    navigate(`/dashboard/contract/${currentContractId}/notes`);

    setAddOrEdit((p) => ({ ...p, open: false }));
  };

  const editData = async (id,status,name,description) => {
    navigate(`/dashboard/contract/${currentContractId}/notes/edit/${id}`);

    if (id) {
      setLoading((p) => ({ ...p, edit: true, loadingId: id }));
      try {
        // const response = await axios.get(`/dashboard/note-quotation/${id}`, {
        //   headers: { Authorization: `Bearer ${token}` },
        // });
        const data = await {status,name,description};
        setLoading((p) => ({ ...p, edit: false, loadingId: "" }));
        setAddOrEdit((p) => ({
          ...p,
          open: true,
          method: "edit",
          // loadedValues: data,
          editId: id,
        }));
        setName(data.name);
        setDescription(data.description);
        setStatus(data.status);
      } catch (err) {
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
      }
    }
  };

  const deleteData = async (id) => {
    if (id) {
      setLoading((p) => ({ ...p, delete: true, loadingId: id }));
      try {
        const response = await axios.delete(`/dashboard/contract-note/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.status === 200) {
          setLoading((p) => ({ ...p, delete: false, loadingId: "" }));
          dispatch(
            setAppError({
              msg: response.data.message,
              color: "bg-green-700",
            })
          );
        }
      } catch (err) {
        setLoading((p) => ({ ...p, delete: false }));

        dispatch(
          setAppError({
            msg: err.message,
          })
        );
        if (err?.response?.status === 403) {
          if (err?.response?.data?.message) {
            dispatch(
              setAppError({
                msg: err?.response?.data.message,
              })
            );
          }
        }
      }
    }
  };

  const addData = () => {
    setAddOrEdit((p) => ({ ...p, open: true, method: "add" }));
    setName("");
    setDescription("");
    setStatus("");
  };

  const dashboardData = useSelector((state) => state.dashboardData);
  const checkAccess = (module, name) =>
    checkAccessFn(dashboardData, module, name);

    const { breadCrumbs } = useSelector(state => state.user);

  useEffect(() => {

      const isEditCostSheetInBreadcrumbs = breadCrumbs.some(
        (crumb) => crumb.label === "NOTES"
      );

      if (!isEditCostSheetInBreadcrumbs && location.pathname.split("/").at(-1) == "notes") {
        dispatch(
          setBreadCrumb([
            ...breadCrumbs,
            {
              label: "NOTES",
              link: `${breadCrumbs?.at(-1).link}/notes`,
            },
          ])
        );
      }
  }, [outletContext?.quotationNumber, location.pathname]);

  return (
    <>
      {showPromptElement.open && (
        <PromptElement
          showPromptElement={showPromptElement}
          setShowPromptElement={setShowPromptElement}
          deleteHandler={deleteData}
        />
      )}
      <div className={`p-2  sm:p-5 `}>
        {!addOrEdit.open && (
          <>
            {checkAccess("Quotation", "quotation-cost-sheet-create") && (
              <Link
                to={`/dashboard/contract/${quotationCostSheetId}/notes/create`}
              >
                <button
                  onClick={addData}
                  className="p-2 bg-red text-white rounded-md"
                >
                  Add New Note +
                </button>
              </Link>
            )}

            <ListDataNotes
              list={clientList}
              editData={editData}
              deleteData={setShowPromptElement}
              loading={loading}
              setStatusUpdate={setStatusUpdate}
              column={5}
              titles={["SL No.", "Name", "Description", "Status", "Action"]}
            />
          </>
        )}
        {addOrEdit.open && (
          <AddEditFormNotes
            component="notes"
            form={[
              {
                type: "text",
                text: "Name",
                name: "name",
                value: name,
                update: setName,
                columnName: "name",
              },
              {
                type: "textarea",
                text: "Description",
                name: "description",
                value: description,
                update: setDescription,
                columnName: "description",
              },
            ]}
            submitForm={submitForm}
            cancelForm={cancelForm}
            submitFormLoading={submitFormLoading}
            loadedValues={addOrEdit.method === "edit" && addOrEdit.loadedValues}
            quotationNumber={outletContext?.quotationNumber}
            currentContractId={currentContractId}
          />
        )}
      </div>
    </>
  );
}
